var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Welcome'),_c('News'),_c('Statistic'),_c('Presentations'),_c('Questions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }